module.exports = __webpack_public_path__ + "images/emoji/post_office.048152eba854d2d2b46a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/post_office.png
// module id = dOg/
// module chunks = 24